module.exports = __webpack_public_path__ + "static/media/add-related-party-icon.ed18c43d.svg";